import { Typography } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { playerIdAtom } from '@/atoms/player/player';
import { playerGameEventDescriptionsAtom } from '@/atoms/queries/player/playerEventData';
import { VideoPlayer } from '@/components/video/VideoPlayer';
import { useFormatVideoEvents } from '@/hooks/useFormatVideoEvents';
import { useSetMetricKey } from '@/hooks/useMetricKey';
import { useRightPanelHeader } from '@/hooks/useRightPanelHeader/useRightPanelHeader';
import { useSetGameIdForVideos } from '@/hooks/useSetGameIdForVideos';
import { useSetIdAtom } from '@/hooks/useSetIdAtom';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';
import { useVideoDataForEvents } from '@/hooks/useVideoDataForEvents';

const PlayerGamesVideoPlayerWithData = () => {
  const playerGameEventDescriptions = useAtomValue(playerGameEventDescriptionsAtom);
  const { videoIds, unavailableVideosCount, ref } = useVideoDataForEvents<HTMLSpanElement>(playerGameEventDescriptions);
  const videoEvents = useFormatVideoEvents(videoIds, playerGameEventDescriptions);

  return (
    <span ref={ref}>
      <VideoPlayer videoEvents={videoEvents} unavailableVideosCount={unavailableVideosCount} />
    </span>
  );
};

const PlayerGamesVideoPlayer = () => {
  const { t } = useTranslation('video');

  return (
    <Suspense
      fallback={
        <Typography variant="bodyMedium" className="p-4">
          {t('loadingVideo')}
        </Typography>
      }
    >
      <div className="p-4">
        <PlayerGamesVideoPlayerWithData />
      </div>
    </Suspense>
  );
};

export const PlayerGamesVideoPreview = () => {
  useSetMetricKey();
  useSetIdAtom(playerIdAtom, 'playerId');
  useSetGameIdForVideos();

  const { t } = useTranslation('video');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);

  useRightPanelHeader(t('player'), () => navigate(`..?${updateQueryString([], undefined)}`));

  return <PlayerGamesVideoPlayer />;
};
